import { PulsingDot } from '@design-system';
import classNames from 'classnames';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';

import { hasFewLeftTag } from '../../../utils/product';

interface Props {
  className?: string;
  tags: string[];
}

export const FewLeft: FC<Props> = ({ className = '', tags }) => {
  const { t } = useTranslation('product');
  const hasFewLeft = hasFewLeftTag(tags);

  if (!hasFewLeft) {
    return null;
  }

  return (
    <p className={classNames('flex items-center gap-2', className)}>
      <PulsingDot /> {t('onlyAFewLeft')}
    </p>
  );
};
